import cognito from '../config/client_cognito.json' assert { type: 'json' };

export class LocalStorageHandler {
  private static userId = '';

  static setUser(userId: string): void {
    this.userId = userId;
  }

  private static getCognitoLastAuthUser(): void {
    this.userId =
      localStorage.getItem(`CognitoIdentityServiceProvider.${cognito.userPoolWebClientId}.LastAuthUser`) ?? '';
  }

  static getUser(): string {
    if (!this.userId) this.getCognitoLastAuthUser();
    return this.userId;
  }

  static save<T = string>(key: string, value?: any): T {
    if (value === null || typeof value === 'undefined') {
      localStorage.removeItem(key);
      return value;
    }
    if (typeof value === 'object') {
      // An empty collection is stored as '[]' / '{}', not dropped. Readers
      // (useStoredState) treat a missing key as "nothing saved, use the
      // default", so deleting it would silently turn a deliberately empty
      // multi-select back into its default on the next load. An empty
      // collection is a choice, and it has to round-trip like any other.
      localStorage.setItem(key, JSON.stringify(value));
      return value;
    }

    localStorage.setItem(key, value);
    return value;
  }

  private static isJsonString(str: string | null): any {
    if (!str) return str;
    try {
      return JSON.parse(str);
    } catch {
      return str;
    }
  }

  static get<T = string>(key: string): T {
    return this.isJsonString(localStorage.getItem(key)) ?? null;
  }
}
